import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=083d0229&scoped=true&"
import script from "./IdentityForm.vue?vue&type=script&lang=js&"
export * from "./IdentityForm.vue?vue&type=script&lang=js&"
import style0 from "./IdentityForm.vue?vue&type=style&index=0&id=083d0229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d0229",
  null
  
)

export default component.exports